import React, { SyntheticEvent } from 'react';
import './style.scss';
import DatePicker from 'react-datepicker';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { Calendar } from '../../../atoms/icons';

interface Props {
    id: string;
    selectedDate: Date | null;
    // eslint-disable-next-line no-unused-vars
    handleChange: (date: Date | null, event?: SyntheticEvent<any, Event> | undefined) => void;
    label?: string | undefined;
    className?: string | undefined;
    dateFormat?: string | undefined;
    minDate?: Date | null | undefined;
    maxDate?: Date | null | undefined;
    disabled?: boolean;
    placeholder?: string;
}

const ReactDatePicker: React.FC<Props> = (props) => {
  const {
    id, selectedDate, handleChange, label, className, maxDate, minDate,
    dateFormat = 'MMMM dd, yyyy', disabled = false, placeholder,
  } = props;
  const [active, setActive] = React.useState(false);
  return (
    <div className={`w-100 ${className}`}>
      <label htmlFor={id} className={label ? 'label' : 'd-none'}>{label}</label>
      <div className="w-100 position-relative d-flex align-items-center">
        <div style={{ position: 'absolute', left: 20, top: 7.5 }}>
          <Calendar color="#A6A6A6" />
        </div>
        <DatePicker
          id={id}
          onChange={(e) => {
            if (e)handleChange(e);
            setActive(false);
          }}
          selected={selectedDate}
          timeIntervals={10}
          dateFormat={dateFormat}
          className="input-datepicker"
          onInputClick={() => setActive(true)}
          onClickOutside={() => setActive(false)}
          showYearDropdown
          showMonthDropdown
          minDate={minDate}
          maxDate={maxDate}
          disabled={disabled}
          placeholderText={placeholder}
        />
        {active ? (
          <KeyboardArrowUp
            sx={{ position: 'absolute', right: 20, color: 'black' }}
          />
        ) : (
          <KeyboardArrowDown
            sx={{ position: 'absolute', right: 20, color: '#A6A6A6' }}
          />
        )}
      </div>
    </div>
  );
};

export default ReactDatePicker;
